// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mpx7","col":"styles_col___igCv"};